import { HUBSPOT_FORM_WINDOW_KEY } from 'ui-forms-embed-components-frame-container/constants/window';
import { MessageTypes } from 'web-interactives-embed-framework';
class ParentMessageDispatcher {
  constructor({
    applicationController
  }) {
    this.sendFormSubmissionSuccessInfo = instanceId => {
      const form = this.getForm(instanceId);
      if (form) {
        this.applicationController.sendMessage({
          type: MessageTypes.SEND_FORM_SUBMISSION_SUCCESS_INFO,
          payload: {
            instanceId,
            redirectUrl: form.getRedirectUrl(),
            conversionId: form.getConversionId()
          }
        });
      }
    };
    this.sendFormReadyEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.V4_FORM_READY,
        payload: formInfo
      });
    };
    this.sendFormSubmissionSuccessEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.SEND_FORM_SUBMISSION_SUCCESS,
        payload: formInfo
      });
    };
    this.sendFormSubmissionFailedEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.SEND_FORM_SUBMISSION_FAILED,
        payload: formInfo
      });
    };
    this.sendFormNavigationEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.SEND_FORM_INTERACTION_NAVIGATE,
        payload: formInfo
      });
    };
    this.sendFormNavigationNextEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.SEND_FORM_INTERACTION_NAVIGATE_NEXT,
        payload: formInfo
      });
    };
    this.sendFormNavigationPreviousEvent = formInfo => {
      this.applicationController.sendMessage({
        type: MessageTypes.SEND_FORM_INTERACTION_NAVIGATE_PREVIOUS,
        payload: formInfo
      });
    };
    if (!applicationController) {
      throw new Error('applicationController is required');
    }
    this.applicationController = applicationController;
  }
  async sendFormFieldValues({
    instanceId
  }) {
    const form = this.getForm(instanceId);
    if (form) {
      try {
        const formFieldValues = await form.getFormFieldValues();
        this.applicationController.sendMessage({
          type: MessageTypes.SEND_FORM_FIELD_VALUES,
          payload: {
            formFieldValues
          }
        });
      } catch (error) {
        throw new Error(String(error));
      }
    }
  }
  async sendFieldValue(instanceId, propertyReference) {
    const form = this.getForm(instanceId);
    if (form) {
      try {
        const fieldValue = await form.getFieldValue(propertyReference);
        this.applicationController.sendMessage({
          type: MessageTypes.SEND_FIELD_VALUE,
          payload: {
            fieldValue
          }
        });
      } catch (error) {
        throw new Error(String(error));
      }
    }
  }
  getForm(instanceId) {
    var _window$HUBSPOT_FORM_;
    const _window = window;
    if (!_window[HUBSPOT_FORM_WINDOW_KEY]) return;
    return (_window$HUBSPOT_FORM_ = _window[HUBSPOT_FORM_WINDOW_KEY].getForms()) === null || _window$HUBSPOT_FORM_ === void 0 ? void 0 : _window$HUBSPOT_FORM_.find(_form => _form.getInstanceId() === instanceId);
  }
}
export class ParentCommunicatorController extends ParentMessageDispatcher {
  initialiseParentCommunicatorControllers(formCommunicators) {
    if (!formCommunicators) {
      throw new Error('formCommunicators is required');
    }
    this.initializeParentFormInstanceMethodListeners(formCommunicators);
  }
  initializeParentFormInstanceMethodListeners(formCommunicators) {
    this.listenForGetFieldValue();
    this.listenForGetFormFieldValues();
    this.listenForSetFieldValue(formCommunicators);
    this.listenForExtraSubmissionMetadata(formCommunicators);
  }
  listenForExtraSubmissionMetadata({
    setExtraSubmissionMetadata
  }) {
    this.applicationController.registerHandler(MessageTypes.SEND_FORM_EXTRA_SUBMISSION_METADATA, props => setExtraSubmissionMetadata(props));
  }
  listenForGetFormFieldValues() {
    this.applicationController.registerHandler(MessageTypes.GET_FORM_FIELD_VALUES, baseFormInfo => {
      this.sendFormFieldValues(baseFormInfo).catch(() => {});
    });
  }
  listenForGetFieldValue() {
    this.applicationController.registerHandler(MessageTypes.GET_FIELD_VALUE, ({
      instanceId,
      propertyReference
    }) => {
      this.sendFieldValue(instanceId, propertyReference).catch(() => {});
    });
  }
  listenForSetFieldValue({
    setFieldValue
  }) {
    this.applicationController.registerHandler(MessageTypes.SET_FIELD_VALUE, props => setFieldValue(props));
  }
}
export const createParentCommunicatorController = props => new ParentCommunicatorController(props);